import { IsString, IsNotEmpty } from 'class-validator';

export class TimezoneUpdateExceptionDto {
  @IsString()
  @IsNotEmpty()
  timezoneId: string;
}
